//
import { type IDebtSolutionsStore } from './debtsolutions.model';

// Grab a particular debt using its debt Id
export const debtGivenDebtId = (state: IDebtSolutionsStore) => (debtID: string) =>
  state.debts.find((item) => item.debtID === debtID);

export const projectedPayoffDateGivenDebtId = (state: IDebtSolutionsStore) => (debtID: string) =>
  state.planWOStacking?.planItemCollection?.find((item) => item.debtId === debtID)
    ?.projectedPayoffDate;

export const debtBalanceForDebtId = (state: IDebtSolutionsStore) => (debtID: string) => {
  return state.debts.find((item) => item.debtID === debtID)?.balance;
};

export const debtMonthlyPaymentForDebtId = (state: IDebtSolutionsStore) => (debtID: string) =>
  state.debts.find((item) => item.debtID === debtID)?.minPayment;

// Unpaid debts
export const unpaidDebts = (state: IDebtSolutionsStore) =>
  state.debts.filter((item) => item.paidOffInd === 0);

// Paid off debts
export const paidOffDebts = (state: IDebtSolutionsStore) =>
  state.debts.filter((item) => item.paidOffInd === 1 || item.balance === 0);

export const getTotalMinPaymentUsinggPaidOffDebts = (state: IDebtSolutionsStore) => {
  let totalMinPayment = 0;
  const tPaidOffDebts = state.debts.filter((item) => item.paidOffInd === 1 || item.balance === 0);
  if (tPaidOffDebts.length) {
    tPaidOffDebts.forEach((element) => {
      totalMinPayment += element.minPayment;
    });
    return totalMinPayment;
  }
  return totalMinPayment;
};

export const planStatus = (state: IDebtSolutionsStore) => {
  // possible values: `-1` no plan, `0` active plan, `1` completed plan
  if (state.debts.length) {
    // if all debts are paid off, return 1;
    // otherwise, return 0
    return unpaidDebts(state).length === 0 ? 1 : 0;
  }
  // return -1 if there are no debts
  return -1;
};

export const twoOrMoreDebtsAndMinOneUnpaidDebt = (state: IDebtSolutionsStore) => {
  if (state.debts.length) {
    const unpaidDebtCount = unpaidDebts(state).length;
    const totalDebt = unpaidDebtCount + paidOffDebts(state).length;
    if (totalDebt >= 2 && unpaidDebtCount >= 1) {
      return true;
    }
    return false;
  }
  return false;
};
export const hasNoPlan = (state: IDebtSolutionsStore) => planStatus(state) === -1;
export const hasActivePlan = (state: IDebtSolutionsStore) => planStatus(state) === 0;
export const hasCompletedPlan = (state: IDebtSolutionsStore) => planStatus(state) === 1;
